
import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { EmailTemplateSelector } from "./EmailTemplateSelector";
import { EmailPreview } from "./EmailPreview";

export function NursingHomeInquiryTest() {
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
  const [templateData, setTemplateData] = useState<any>(null);

  const handleSelectTemplate = (template: string, data: any) => {
    setSelectedTemplate(template);
    setTemplateData(data);
  };

  const handleBack = () => {
    setSelectedTemplate(null);
    setTemplateData(null);
  };

  return (
    <Card>
      <CardContent className="pt-6">
        {!selectedTemplate ? (
          <EmailTemplateSelector onSelectTemplate={handleSelectTemplate} />
        ) : (
          <EmailPreview 
            templateType={selectedTemplate}
            templateData={templateData}
            onBack={handleBack}
          />
        )}
      </CardContent>
    </Card>
  );
}
